// src/OtpVerify.js
import React, { useState } from "react";
import { useNavigate } from "react-router";

const OtpVerify = () => {
  const [otp, setOtp] = useState(new Array(6).fill("")); // Array of 6 for OTP
  const [otpError, setOtpError] = useState("");
  const navigate = useNavigate();

  const handleOtpSubmit = (e) => {
    e.preventDefault();

    const otpValue = otp.join(""); // Join OTP digits into a single string
    if (otpValue.length === 6 && /^[0-9]{6}$/.test(otpValue)) {
      console.log("OTP submitted:", otpValue);
      setOtpError("");
      // Handle OTP submission (call API, etc.)
    } else {
      console.log("Invalid OTP");
      setOtpError("Please enter a valid 6-digit OTP.");
    }
  };

  const handleOtpChange = (element, index) => {
    const value = element.value;

    if (/^[0-9]$/.test(value)) {
      let newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input field or submit OTP when filled
      if (index === 5) {
        // If last digit is filled, submit OTP or navigate
        const otpValue = newOtp.join("");
        if (otpValue.length === 6 && /^[0-9]{6}$/.test(otpValue)) {
          console.log("OTP submitted:", otpValue);
          navigate("/"); // Navigate to the home page
        }
      } else if (element.nextSibling) {
        element.nextSibling.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      let newOtp = [...otp];
      newOtp[index] = ""; // Clear the current value

      setOtp(newOtp);
      // Move to the previous input field
      if (e.target.previousSibling) {
        e.target.previousSibling.focus();
      }
    }
  };

  return (
    <div className="login-container py-3">
      <div className="login-form">
        <>
          <div className="text-center py-5">
            <img src="https://wallet.ahrvo.network/static/media/msgIcon.aa77e50d63afde5310961f265d4d704b.svg" />
            <p className="enter_title">Please enter the code sent to</p>
            <h3 className="enter_email">ahrvo@info.com</h3>
          </div>
          <form onSubmit={handleOtpSubmit} style={{ marginBottom: "80px" }}>
            <div className="form-group text-left">
              <div className="otp-inputs">
                {otp.map((value, index) => (
                  <input
                    key={index}
                    type="text"
                    className="otp-input"
                    maxLength="1"
                    value={value}
                    onChange={(e) => handleOtpChange(e.target, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)} // Backspace handling
                    onFocus={(e) => e.target.select()}
                    required
                  />
                ))}
              </div>
              {otpError && <p className="error_msg">{otpError}</p>}
            </div>
          </form>
        </>

        <div className="card_footer mt-4">
          <div className="footer_logo_img">
            <img
              src="https://backendmarketplace.ahrvoid.com/media/logo_images/marketplace_BAHkiPW.png"
              alt="Logo"
              width={70}
            />
          </div>
          <div className="secured">
            <span>Secured by </span>
            <span className="footer_logo">logo</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpVerify;
